/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { restartableTask, Task } from 'ember-concurrency';
import DS from 'ember-data';
import { inject as service } from '@ember/service';
import EnvironmentModel from 'cio/models/environment';
import { queryEncode } from 'cio/helpers/query';

interface SelfServeMigrationModalMultiIdToIdArgs {
  environment: EnvironmentModel;
  readOnly?: boolean;
  onClose: () => unknown;
  onStart: Task<unknown, any[]>;
  haveIdentifiersChanged: boolean;
  email: string;
}

export default class SelfServeMigrationModalMultiIdToId extends Component<SelfServeMigrationModalMultiIdToIdArgs> {
  @service store!: DS.Store;

  readonly peopleFilter = queryEncode({
    and: [
      {
        not: {
          attribute: {
            field: 'id',
            operator: 'exists',
          },
        },
      },
    ],
  });

  get hasPeopleWithoutIds() {
    return (this.checkForMissingIds.last?.value ?? 0) > 0;
  }

  get title() {
    if (this.hasPeopleWithoutIds) {
      return 'Hold on!';
    }

    return "You're about to disable email as an identifier";
  }

  checkForMissingIds = restartableTask(async () => {
    let people = await this.store.query('customer', {
      filters: this.peopleFilter,
    });

    return (people as any).meta?.pagination?.total ?? 0;
  });
}
